// DrawingContext.js
import { createContext, useEffect, useState } from 'react';

interface DrawingContextType {
  drawingMode: string | null;
  setDrawingMode: (drawingMode: string | null) => void;
  coords: any;
  setCoords: (coords: any) => void;
  drawingFeatureType: string | null;
  setDrawingFeatureType: (drawingFeatureType: string | null) => void;
  geojson: any;
  setGeojson: (geojson: any) => void;
}

const DrawingContext = createContext<DrawingContextType>({
  drawingMode: null,
  setDrawingMode: () => {},
  coords: [],
  setCoords: () => {},
  drawingFeatureType: null,
  setDrawingFeatureType: () => {},
  geojson: null,
  setGeojson: () => {},
});

export const DrawingMode = {
  NONE: null,
  ASSET: "Asset",
  TREATMENT: "Treatment",
  NOTE: "Note",
  IGNITION: "Ignition",
  VEGETATION_EDIT: "Vegetation Edit",
  // The area a vegetation refinement looks at, traced in the editor.
  DATA_AREA: "Data Area",
  MEASURE: "Measure",
}

export const DrawingFeatureType = {
  NONE: null,
  POLYGON: "Polygon",
  POINT: "Point",
  LINE: "Line",
  UPLOAD: "Upload",
}

interface DrawingProviderProps {
  children: React.ReactNode;
}

const DrawingProvider: React.FC<DrawingProviderProps> = ({ children }) => {
  const [ drawingMode, setDrawingMode ] = useState<string | null>(DrawingMode.NONE);
  const [ drawingFeatureType, setDrawingFeatureType ] = useState<string | null>(DrawingFeatureType.NONE);
  const [ coords, setCoords ] = useState([]);
  const [ geojson, setGeojson ] = useState(null);

  const value = { drawingMode,
                  setDrawingMode,
                  coords,
                  setCoords,
                  drawingFeatureType,
                  setDrawingFeatureType,
                  geojson,
                  setGeojson };

  useEffect(() => {
    if (drawingMode === DrawingMode.NONE && drawingFeatureType === DrawingFeatureType.NONE){
      setCoords([]);
      setGeojson(null);
    }
  }, [drawingMode, drawingFeatureType]);

  return (
    <DrawingContext.Provider value={ value }>
      {children}
    </DrawingContext.Provider>
  );
};

export { DrawingContext, DrawingProvider };